<script>
import Navbar from "./Navbar/Index";
import Footer from "./Footer";
import PendingCyclePaymentsNotice from "@/components/_Shared/Warnings/PendingCyclePayments";
import ClosedCitiesNotice from "@/components/_Shared/Warnings/ClosedCities";
import EmailNotVerifiedNotice from "@/components/_Shared/Warnings/EmailNotVerified/Notice";
import EmailNotVerifiedDialog from "@/components/_Shared/Warnings/EmailNotVerified/Dialog";

import freshDesk from "@/utils/freshDesk";
import actionCable from "@/utils/actionCable";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    Navbar,
    Footer,
    PendingCyclePaymentsNotice,
    ClosedCitiesNotice,
    EmailNotVerifiedNotice,
    EmailNotVerifiedDialog
  },

  computed: {
    ...mapState("user", ["user"])
  },

  methods: {
    ...mapActions("user", ["getUser"]),

    initializeCable() {
      this.$cable._cable.url = actionCable.buildURL();
      this.$cable.subscribe({ channel: "AccountChannel" });
    }
  },

  channels: {
    AccountChannel: {
      received(data) {
        this.getUser(this.user.id);
      }
    }
  },

  mounted() {
    this.initializeCable();
    freshDesk.identifyUser(this.user.email);
  }
};
</script>


<template>
  <div class="wrapper">
    <navbar />

    <div class="content-wrapper">
      <pending-cycle-payments-notice />
      <closed-cities-notice />
      <email-not-verified-notice />
      <email-not-verified-dialog />

      <keep-alive>
        <transition name="zoom" mode="out-in">
          <router-view />
        </transition>
      </keep-alive>
    </div>

    <Footer />
  </div>
</template>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
}
.content-wrapper {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 240px);
  padding: 50px 0 25px 0;
}

@media (max-width: 992px) {
  .content-wrapper {
    min-height: calc(100vh - 150px);
    padding: 10px 0 25px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue